import React from 'react'
import moment from 'moment'
import { Card, Button, List, Label } from 'semantic-ui-react'
import _ from 'lodash'

const styles = {
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  actionButton: {
    display: 'flex',
    flexDirection: 'row',
  },
}

const Row = ({ field, value, color }) => {
  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ display: 'flex', flex: 1 }}>{field}</div>
        <div style={{ display: 'flex' }}>
          <Label size="medium" color={color}>
            {value}
          </Label>
        </div>
      </List.Content>
    </List.Item>
  )
}

export default ({ merchandiseCode, onViewClick }) => {
  const createdAt = moment(merchandiseCode.created_at).format('DD-MMM-YYYY')
  const codeCount = _.size(merchandiseCode.codes)
  const redemptionCount = _.size(_.filter(merchandiseCode.codes, code => code.redeemed))

  return (
    <Card style={{ marginRight: 30 }}>
      <Card.Content>
        <Card.Header>{merchandiseCode.merchant_name}</Card.Header>
        <Card.Description>
          <List divided verticalAlign="middle" style={{ marginTop: 10 }}>
            <Row field="ID" value={merchandiseCode.id} />
            <Row field="Codes" value={codeCount} />
            <Row field="Redemption" value={redemptionCount} color="green" />
            <Row field="Created at" value={createdAt} />
          </List>
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <div style={styles.actionButton}>
          <Button color="black" onClick={onViewClick} size="tiny" style={{ width: '100%' }}>
            View
          </Button>
        </div>
      </Card.Content>
    </Card>
  )
}



// WEBPACK FOOTER //
// ./src/containers/rewards/MerchandiseCodes/components/Card.js